// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--ursb-crr-smb-inbox-const-styl-box{
    width: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.scl--ursb-crr-smb-item-content-styl.ocasion{
    display: flex;
}

.scl--ursb-crr-smb-spec-sm-item:first-child{
    width: 162px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.scl--ursb-crr-smb-spec-sm-item:last-child{
    padding-left: 20px;
    width: calc(100% - 162px);
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-transform: capitalize;
}

.scl--ursb-crr-smb-item-content-styl.normal{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.scl--ursb-crr-smb-item-content-styl span{
    font-size: 14px;
    font-family: var(--font-family-inter);
    color: var(--typography-text-body-secondary);
}

.scl--ursb-crr-smb-item-content-styl h6{
    font-family: var(--font-family-inter);
    font-size: 16px;
    padding: 0;
    margin: 0;
    color: var(--typography-text-body-primary);
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.scl--ursb-crr-smb-file-display-styl{
    width: 100%;
    display: flex;
    padding: 16px;
    height: 75px;
    border-radius: 10px;
    border: 1px dashed rgba(138, 139, 143, 1);
    gap: 10px;
}

.scl--ursb-crr-smb-file-display-styl .no-file{
    font-size: 14px;
    color: var(--typography-text-body-primary);
    font-family: var(--font-family-inter);
}

.scl--ursb-crr-smb-file-display-styl:hover .scl--ursb-crr-smb-file-ds-title h5{
    text-decoration: underline;
}

.scl--ursb-crr-smb-file-display-styl svg{
    width: 39px;
    height: 43px;
}

.scl--ursb-crr-smb-file-ds-title{
    width: calc(100% - 95px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    justify-content: center;
}

.scl--ursb-crr-smb-file-ds-title h5{
    padding: 0;
    margin: 0;
    color: var(--typography-text-body-primary);
    font-weight: 500;
    font-family: var(--font-family-inter);
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.scl--ursb-crr-smb-file-ds-title .span-mock{
    color: var(--typography-text-body-secondary);
    font-weight: 500;
    font-family: var(--font-family-inter);
    font-size: 8px;
}

.scl--ursb-crr-smb-item-content-styl .message-box {
    width: 100%;
    min-height: 100px;
    max-height: 250px;
    height: auto;
    overflow-y: auto;

    border: 1px solid rgba(138, 139, 143, 1);
    font-size: 14px;
    color: var(--typography-text-body-primary);
    font-family: var(--font-family-inter);
    border-radius: 10px;
    padding: 16px 10px;
    line-height: 20px;

    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: break-word;
}

.scl--ursb-crr-smb-btn-decision-styl{
    width: 100%;
    display: flex;
    padding-top: 10px;
    gap: 8px;
    justify-content: end;
}

.scl--ursb-crr-smb-file-display-styl button{
    border: none;
    background: transparent;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s;
}

.scl--ursb-crr-smb-file-display-styl button svg{
    width: 25px;
    height: 25px;
}

.scl--ursb-crr-smb-file-display-styl:hover button{
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/career/css/ursb-submit.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,4CAA4C;AAChD;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,UAAU;IACV,SAAS;IACT,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,SAAS;AACb;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,0CAA0C;IAC1C,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;;IAEhB,wCAAwC;IACxC,eAAe;IACf,0CAA0C;IAC1C,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;;IAEjB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".scl--ursb-crr-smb-inbox-const-styl-box{\n    width: 100%;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.scl--ursb-crr-smb-item-content-styl.ocasion{\n    display: flex;\n}\n\n.scl--ursb-crr-smb-spec-sm-item:first-child{\n    width: 162px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.scl--ursb-crr-smb-spec-sm-item:last-child{\n    padding-left: 20px;\n    width: calc(100% - 162px);\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    text-transform: capitalize;\n}\n\n.scl--ursb-crr-smb-item-content-styl.normal{\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.scl--ursb-crr-smb-item-content-styl span{\n    font-size: 14px;\n    font-family: var(--font-family-inter);\n    color: var(--typography-text-body-secondary);\n}\n\n.scl--ursb-crr-smb-item-content-styl h6{\n    font-family: var(--font-family-inter);\n    font-size: 16px;\n    padding: 0;\n    margin: 0;\n    color: var(--typography-text-body-primary);\n    font-weight: 400;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.scl--ursb-crr-smb-file-display-styl{\n    width: 100%;\n    display: flex;\n    padding: 16px;\n    height: 75px;\n    border-radius: 10px;\n    border: 1px dashed rgba(138, 139, 143, 1);\n    gap: 10px;\n}\n\n.scl--ursb-crr-smb-file-display-styl .no-file{\n    font-size: 14px;\n    color: var(--typography-text-body-primary);\n    font-family: var(--font-family-inter);\n}\n\n.scl--ursb-crr-smb-file-display-styl:hover .scl--ursb-crr-smb-file-ds-title h5{\n    text-decoration: underline;\n}\n\n.scl--ursb-crr-smb-file-display-styl svg{\n    width: 39px;\n    height: 43px;\n}\n\n.scl--ursb-crr-smb-file-ds-title{\n    width: calc(100% - 95px);\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    justify-content: center;\n}\n\n.scl--ursb-crr-smb-file-ds-title h5{\n    padding: 0;\n    margin: 0;\n    color: var(--typography-text-body-primary);\n    font-weight: 500;\n    font-family: var(--font-family-inter);\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.scl--ursb-crr-smb-file-ds-title .span-mock{\n    color: var(--typography-text-body-secondary);\n    font-weight: 500;\n    font-family: var(--font-family-inter);\n    font-size: 8px;\n}\n\n.scl--ursb-crr-smb-item-content-styl .message-box {\n    width: 100%;\n    min-height: 100px;\n    max-height: 250px;\n    height: auto;\n    overflow-y: auto;\n\n    border: 1px solid rgba(138, 139, 143, 1);\n    font-size: 14px;\n    color: var(--typography-text-body-primary);\n    font-family: var(--font-family-inter);\n    border-radius: 10px;\n    padding: 16px 10px;\n    line-height: 20px;\n\n    white-space: pre-wrap;\n    word-break: break-word;\n    overflow-wrap: break-word;\n}\n\n.scl--ursb-crr-smb-btn-decision-styl{\n    width: 100%;\n    display: flex;\n    padding-top: 10px;\n    gap: 8px;\n    justify-content: end;\n}\n\n.scl--ursb-crr-smb-file-display-styl button{\n    border: none;\n    background: transparent;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    opacity: 0;\n    transition: all 0.3s;\n}\n\n.scl--ursb-crr-smb-file-display-styl button svg{\n    width: 25px;\n    height: 25px;\n}\n\n.scl--ursb-crr-smb-file-display-styl:hover button{\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
